import { isToday, isTomorrow, isBefore, isSameDay, isSameWeek, addDays, parseISO, startOfDay } from 'date-fns';

/**
 * Raggruppamento del pannello "Le mie attivita'" dell'header (ActivitiesDrawer).
 * Le task senza scadenza hanno un gruppo proprio (segnalazione 284ed7c2: il contatore le
 * contava ma la lista le scartava, e il pannello si apriva vuoto con il pallino a 4).
 */
export interface DatedActivity {
  due_date: string | null;
}

export const ACTIVITY_GROUP_ORDER = ['overdue', 'today', 'tomorrow', 'this_week', 'later', 'no_date'] as const;
export type ActivityGroupKey = (typeof ACTIVITY_GROUP_ORDER)[number];

export function groupActivitiesByDue<T extends DatedActivity>(activities: T[], now: Date = new Date()): Record<ActivityGroupKey, T[]> {
  const today = startOfDay(now);
  const groups: Record<ActivityGroupKey, T[]> = { overdue: [], today: [], tomorrow: [], this_week: [], later: [], no_date: [] };
  activities.forEach((activity) => {
    if (!activity.due_date) {
      groups.no_date.push(activity);
      return;
    }
    const dueDate = parseISO(activity.due_date);
    if (isBefore(startOfDay(dueDate), today)) groups.overdue.push(activity);
    // Sempre rispetto a `now` (non all'orologio reale), cosi' il raggruppamento e' coerente
    else if (isSameDay(dueDate, today)) groups.today.push(activity);
    else if (isSameDay(dueDate, addDays(today, 1))) groups.tomorrow.push(activity);
    else if (isSameWeek(dueDate, today, { weekStartsOn: 1 })) groups.this_week.push(activity);
    else groups.later.push(activity);
  });
  return groups;
}

/** Ordinamento per scadenza crescente, le task senza scadenza in fondo. */
export function compareByDueDate(a: DatedActivity, b: DatedActivity): number {
  const ta = a.due_date ? new Date(a.due_date).getTime() : Number.POSITIVE_INFINITY;
  const tb = b.due_date ? new Date(b.due_date).getTime() : Number.POSITIVE_INFINITY;
  if (ta === tb) return 0;
  return ta < tb ? -1 : 1;
}

export function formatActivityDueDate(dateString: string | null): { text: string; isOverdue: boolean; isToday: boolean } {
  if (!dateString) return { text: 'Senza scadenza', isOverdue: false, isToday: false };
  const date = parseISO(dateString);
  const today = startOfDay(new Date());
  const dateOnly = startOfDay(date);
  if (isBefore(dateOnly, today)) {
    const daysAgo = Math.ceil((today.getTime() - dateOnly.getTime()) / (1000 * 60 * 60 * 24));
    return { text: daysAgo === 1 ? 'Ieri' : `${daysAgo}g fa`, isOverdue: true, isToday: false };
  }
  if (isToday(date)) return { text: 'Oggi', isOverdue: false, isToday: true };
  if (isTomorrow(date)) return { text: 'Domani', isOverdue: false, isToday: false };
  return { text: date.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' }), isOverdue: false, isToday: false };
}
